var separator = 'separator_separator__l4z92i0';

export { separator };
//# sourceMappingURL=separator.vanilla.mjs.map
